import type { AuctionCarTransaction } from "@/types/auctions";

export type AuctionResult = AuctionCarTransaction["result"];

export type AuctionResultBadgeColors = {
  backgroundColor: string;
  color: string;
};

export type AuctionResultBadgeColorOverrides = Partial<
  Record<AuctionResult, AuctionResultBadgeColors>
>;

const DEFAULT_AUCTION_RESULT_BADGE_COLORS: Record<AuctionResult, AuctionResultBadgeColors> = {
  sold_at_auction: { backgroundColor: "#FFE3E3", color: "#C92A2A" },
  sold_post_auction: { backgroundColor: "#FFE3E3", color: "#C92A2A" },
  sold: { backgroundColor: "#FFE3E3", color: "#C92A2A" },

  not_sold: { backgroundColor: "#FFF4E6", color: "#AD4B00" },
  withdrawn: { backgroundColor: "#FFF4E6", color: "#AD4B00" },
  expired: { backgroundColor: "#FFF4E6", color: "#AD4B00" },

  upcoming_auction: { backgroundColor: "#E7F5FF", color: "#4361C1" },
  for_sale: { backgroundColor: "#E6FCF5", color: "#087F5B" },

  unknown: { backgroundColor: "#F1F3F5", color: "#495057" },
  not_available: { backgroundColor: "#F1F3F5", color: "#495057" },
};

export function getAuctionResultBadgeColors(
  result: AuctionResult | null | undefined | "",
  overrides?: AuctionResultBadgeColorOverrides
): AuctionResultBadgeColors | null {
  const normalized = typeof result === "string" ? result.trim() : "";
  if (!normalized) return null;

  const key = normalized as AuctionResult;
  return overrides?.[key] ?? DEFAULT_AUCTION_RESULT_BADGE_COLORS[key] ?? null;
}
